import React from 'react'
import { Button } from 'reactstrap'
import { Field, reduxForm } from 'redux-form'
import FormattedMessage from '../../FormattedMessage/FormattedMessage'
import { renderField } from '../../../utilities/reduxForm.util'
import { required } from '../../../utilities/validators'
import Loader from '../../Loader/Loader'

const ModalButton = ({ toggle }) => (
  <Button
    color="dark"
    block
    type="submit"
    name="faqVoteModalSubmitBtn"
    onClick={toggle}
    aria-label="Submit feedback"
  >
    <FormattedMessage id="global.label.submit" />
  </Button>
)

const FaqVoteModalForm = ({ faqModalLoading, handleSubmit, error, toggle }) => (
  <form onSubmit={handleSubmit} method="post" name="loginForm" aria-labelledby="feedback-heading">
    <div disabled={faqModalLoading}>
      <div className="sr-only">Feedback form</div>
      <h3 id="feedback-heading">
        <FormattedMessage id="global.label.feedbackQuestion" />
      </h3>
      <Field
        component={renderField}
        validate={[required]}
        inputType="textarea"
        type="text"
        name="feedbackResponse"
        aria-describedby="feedbackResponse"
        label="global.label.yourComments"
      />
      {error && (
        <div className="form-validation-error-message mb-2" role="alert" aria-live="polite">
          <FormattedMessage id={error} />
        </div>
      )}
      <br />
      {faqModalLoading ? (
        <Loader aria-label="Submitting feedback" />
      ) : (
        <ModalButton toggle={toggle} />
      )}
    </div>
  </form>
)

export default reduxForm({
  form: 'FaqVoteModalForm',
})(FaqVoteModalForm)
